import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleDelete } from '../../../utils/AxiosUtil';

class RemovePayableFromGroup extends Component {
    componentDidMount() {
        console.log(this.props.row);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        let requestObject = {
            "payableId": this.props.row.privateId,
            "type": this.props.row.rowType
        };
        console.log(requestObject);
        handleDelete("/api/grouppayable", requestObject, this);
    };

    handleSuccess = (res) => {
        this.props.refresh();
        this.props.close();
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                <h3>Biztos hogy el szeretnéd távolítani a csoportból?</h3>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit" autoFocus={true}>
                        Igen
                    </Button>
                </div>
            </form>

        )
    }
}

export default withSnackbar(RemovePayableFromGroup);
